export const firebaseConfig = {
  apiKey: 'AIzaSyDVh2mw7fAgHPQLq8bpTDBxE-OVAmf0nYs',
  authDomain: 'care4kids-96e84.firebaseapp.com',
  projectId: 'care4kids-96e84',
  storageBucket: 'care4kids-96e84.appspot.com',
  messagingSenderId: '669179809428',
  appId: '1:669179809428:web:71c12c7e123beb5ce7ee81',
};
